module.exports = {
	"articleTitle1": "Housing gives sign-up priority to underclassmen",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Couzens Hall",
	"articleLink1": "https://www.michigandaily.com/news/new-u-housing-plan",
	"articleLink2": "https://www.michigandaily.com/news/coleman-speaks-couzens-hall-dedication",
	"articleSnippet1": "Dec 8, 2011 ... Adam Glanzman/Daily Residence Hall Association representatives discuss the \nnew sign-up process at a meeting in Couzens Hall on Thursday ...",
	"articleSnippet2": "Oct 11, 2011 ... Equipped with wireless Internet, air conditioning, a game room and a kitchen for \nstudent use, the updated Couzens Residence Hall is far from ...",
	"totalMisc": 1,
	"articleTitle2": "Couzens renovation lauded at dedication",
	"address": "1300 E Ann St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.2819,
		"lng": -83.732565
	},
	"tips": [
		{
			"text": "The outdoor patio is very cool.",
			"person": "Andrew Fridenberg"
		},
		{
			"text": "They have nice rooms with pianos for practicing.",
			"person": "Andrew Fridenberg"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "All floors"
		}
	],
	"categories": {
		"dorm": 1,
		"housing": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/couzens.json
// module id = 857
// module chunks = 0